import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useParams } from 'react-router-dom';
import { Col, Container, Row } from 'react-bootstrap';
import TripHistoryChart from './TripHistoryChart';
import TripHistoryTable from './TripHistoryTable';
import TripHistorySummary from './TripHistorySummary';
import { getEgRoundTrip } from '../../actions/equipment-group';
import { hideOverlay, showOverlay } from '../../actions/toast';
import { ButtonGroupToggle, Heading5, Heading6 } from '../widgets';
import '../../../assets/scss/tripHistory.scss';

const RoundTrip = props => {
    const { custom, roundTripList, timezoneIdentifier, isRequesting } = props;
    const [data, setData] = useState([]);
    const [selectedViewType, setSelectedViewType] = useState(1);
    const tabs = [
        { value: 0, label: "Trips Chart" },
        { value: 1, label: "Trips Summary" },
        { value: 2, label: "Trips History" }
    ]

    const params = useParams();
    const farmId = params.farmId;

    useEffect(() => {
        if (!custom) return;
        const params = {
            farmId: farmId,
            startDate: custom.from,
            endDate: custom.to,
            is_include_name: true
        };

        props.actions.getEgRoundTrip(params);
    }, [custom]);

    useEffect(() => {
        if (isRequesting) props.actions.showOverlay({ text: "Loading..." });
        else props.actions.hideOverlay();
    }, [isRequesting]);

    useEffect(() => {
        if (roundTripList && roundTripList.length === 0) return setData([]);
        const eventData = roundTripList.sort((a, b) => new Date(b.ts).valueOf() - new Date(a.ts).valueOf());
        let groupedData = [];
        for (const event of eventData) {
            groupedData.push({
                eg: event.equipment_group_name,
                enter: event.events["enter"] && event.events["enter"].ts ? event.events["enter"].ts : null,
                exit: event.events["exit"] && event.events["exit"].ts ? event.events["exit"].ts : null,
                regionName: event.region.geo_region_uuid ? event.region.geo_region_name : null,
                regionId: event.region.geo_region_uuid ? event.region.geo_region_uuid : null
            })
        }
        setData(groupedData);
    }, [roundTripList]);


    return (
        <Container fluid
            style={{ overflow: 'scroll', backgroundColor: 'white', padding: '30px', paddingTop: '5px' }}
            className='tripHistory'>

            <Row className="header mx-2 my-4 ">
                <Col className="title-details col-12">
                    <Heading5 className="d-inline title">Trips History</Heading5>
                    <Heading6 className="d-inline text-muted"> - Push Tractor</Heading6>
                </Col>
            </Row>

            {!isRequesting ? <>
                <div className='text-center my-4'>

                    <ButtonGroupToggle
                        options={tabs}
                        value={selectedViewType} onSelect={(type) => setSelectedViewType(type)}
                        className="btn-group-toggle" />
                </div>
                <Row className={`m-0 ${selectedViewType === 2 ? "show" : "hide"}`}>
                    <div className="trip-table"> <TripHistoryTable data={data} isRequesting={isRequesting} timezoneIdentifier={timezoneIdentifier} /></div>
                </Row>
                <Row className={`m-0 ${selectedViewType === 1 ? "show" : "hide"}`}>
                    <TripHistorySummary data={data} isRequesting={isRequesting} timezoneIdentifier={timezoneIdentifier} />
                </Row>
                <Row className={`m-0 ${selectedViewType === 0 ? "show" : "hide"}`}>
                    <TripHistoryChart data={data} searchParams={custom} isRequesting={isRequesting} timezoneIdentifier={timezoneIdentifier} />
                </Row>
            </> : null}
        </Container>
    )
}

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({ getEgRoundTrip, hideOverlay, showOverlay }, dispatch)
});

const mapStateToProps = state => ({
    custom: state.analyze.searchParams.custom,
    roundTripList: state.equipmentGroup.roundTripList,
    timezoneIdentifier: state.farm.currentFarm.timezone_identifier,
    isRequesting: state.equipmentGroup.isRequesting
});

export default connect(mapStateToProps, mapDispatchToProps)(RoundTrip);